import moment from 'moment';
import 'moment/locale/ru';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';
import { errorCatch, GET, If, JSXMap, useAuth } from 'fennec-ui';
import { Action } from 'fennec-ui'
import QRCode from "react-qr-code";
import { Button, Collapse, SwipeAction } from 'antd-mobile';
import Icofont from 'react-icofont';
import Block from '../../../../../components/Block';
import EventListItem from '../../../../../components/EventListItem';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { eventRoleControler } from '../../../../../../common/Tool';
import { useTranslation } from 'react-i18next';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');

const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 0px",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .adm-list-item-content': {
			color: 'black',
			padding: "0px 10px"
		},
		'& .adm-list-item-content-arrow > .adm-collapse-arrow-active': {
			transform: "translateY(-6px) rotate(-180deg)",
		}
		// '& .ant-collapse-content > .ant-collapse-content-box': {
		// 	padding: "6px"
		// },
		// '&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
		// 	paddingTop: "0px",
		// 	paddingBottom: "0px"
		// }
	},
	swipeWithHelper: {
		'& .am-swipe-content': {
			position: "relative",
			overflow: "hidden",
			// clipPath: "polygon(0 -1%, 100% -1%, 100% 35%, 85% 100%, 0 100%)",
		},
		'& .adm-button': {
			backgroundColor: 'white',
		}
	}
})

const QR = (props) => {
	const auth = useAuth();
	const { event, code, trigger } = props;
	return <div>
		<Action
			auth={auth}
			action={(values, unlock, close) => {
			}}
			object={code}
			modal={{
				title: "QR"
			}}

			readonly={true}
			mode={"func"}
			noAntForm={true}
			form={(props) => {
				const { object } = props;
				return <div>
					{object &&
						<div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: "15px", alignItems: "center" }}>
							{event && <div style={{ paddingBottom: "10px" }}>
								<SingleEvent auth={auth} event={event} size="small" />
							</div>}
							<div style={{
								textAlign: "center",
								backgroundColor: "white",
								padding: "10px",
								borderRadius: "8px",
								border: "1px solid #cdcdcd"
							}}>
								<QRCode bgColor='white' size={300} level="M" value={object} />
							</div>
							<div>
								{(!!auth) &&
									<a className='btn btn-primary btn-sm' href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch/${event.ID}`}>Войти в мероприятие</a>
								}
							</div>
						</div>}
				</div>
			}}
			trigger={trigger ? trigger : (click) => (
				<Button type="text" onClick={event => {
					event.stopPropagation();
					click();
				}}>
					<div style={{ padding: "3px", backgroundColor: "white", borderRadius: "6px" }}>
						<QRCode size={30} value={code} />
					</div>
				</Button>
			)}
		/>
	</div>
}
const Uslugi = (props) => {
	const classes = useStyles();
	const auth = useAuth();
	const { e, trigger } = props;
	const appendYacheikaUsluga = (arr, tick) => {
		let a = (arr) ? [...arr] : [];
		a.push({
			...tick.uslugaKlientu.yacheikaUsluga,
			kategoriya: (tick.kategoriya && tick.kategoriya.kategoriya) ? tick.kategoriya.kategoriya : undefined,
		});

		return a.sort(function (a, b) {
			if (a.kategoriya && !b.kategoriya) {
				return -1;
			}
			if (!a.kategoriya && b.kategoriya) {
				return 1;
			}
			return 0;
		});;
	};
	const ticket = () => {
		let m = {};

		for (let i = 0; i < e.TicketList.length; i++) {
			const tick = e.TicketList[i];
			let o = m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] || tick.uslugaKlientu.uslugaNaMeropriyatii;
			o = {
				...o,
				summa: ((o.summa) ? o.summa : 0) + tick.summa,
				yacheikaUsluga: appendYacheikaUsluga(o.yacheikaUsluga, tick),
			};
			m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] = o;
		}
		return Object.values(m);
	};
	return <div>
		<Action
			auth={auth}
			action={(values, unlock, close) => {
			}}
			modal={{
				title: "Услуги на мероприятии"
			}}

			readonly={true}
			mode={"func"}
			noAntForm={true}
			form={(props) => {
				const { object } = props;
				return <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: "15px", alignItems: "center" }}>
					{(e && e.Meropriyatie) && <div style={{ paddingBottom: "10px" }}>
						<SingleEvent auth={auth} event={e.Meropriyatie} size="small" />
					</div>}
					<div style={{ display: "flex", width: "100%", padding: "0px 10px", flexDirection: "column", gap: "15px" }}>

						{JSXMap(ticket(), (t, idx) => {
							return (<div key={t.ID} className={classes.ticket} style={{ display: "flex", width: "100%" }}>
								<div className={classes.ticketHeader} style={{ flex: "auto" }}>
									<div className={classes.ticketName} style={{ fontWeight: "500", color: "#333", fontSize: "15px" }}>
										<div style={{ display: "flex", justifyContent: "space-between" }}>
											<div>{t.nazvanie}</div>
											{/* <div style={{ flex: "auto", margin: "10px 10px", height: "1px", borderColor: "#f0f0f0", borderWidth: "1px", borderStyle: "dotted" }}></div> */}
										</div>
									</div>
									{t.opisanie && <div style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.45)" }}>
										{t.opisanie}
									</div>}
									{JSXMap(t.yacheikaUsluga, (y, idx) => {
										return <div key={idx}>
											<div style={{ paddingLeft: "5px", fontSize: "13px", color: "#333" }}>
												{" - " + y.nazvanie}
												{(y.kategoriya) &&
													<span>
														<span> - </span>
														<span style={{ color: "#1890ff", fontStyle: "italic" }}>
															{y.kategoriya.tantsevalnayaDistsiplina.nazvanie + " / " + y.kategoriya.kategoriyaUchastnikov.nazvanie}
														</span>
													</span>
												}
											</div>
										</div>
									})}
								</div>
								<div style={{ flex: "1 1 65px" }}>
									<div style={{ alignSelf: "flex-start", color: "rgb(63, 134, 0)", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "400", fontSize: "11px" }}>
										Оплачено:
									</div>
									<div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", padding: "0px 0px 0px 15px", fontWeight: "500", fontSize: "14px" }}>
										<div style={{ color: "rgb(63, 134, 0)" }}>{Number((t.summa).toFixed(2)).toLocaleString('ru', { style: 'currency', currency: 'RUB' })}</div>
									</div>
								</div>
							</div>)
						})}
					</div>
				</div>
			}}
			trigger={trigger}
		/>
	</div>
}
const SingleEvent = (props) => {
	const classes = useStyles();
	const auth = useAuth();
	const { event, size } = props;

	if (!event) return <></>;
	return (
		<div className="event-block" style={{ display: "flex", flexDirection: "column" }}>

			<div style={{ flex: "auto", paddingLeft: "7px" }}>
				<div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldValue} style={{ fontWeight: "500", fontSize: (size !== "small") ? "20px" : "26px" }}>
					<a href={`/fed/event/${event.ID}`}>{event.nazvanieMeropriyatiya}</a>
						</span>
				</div>
				{/* <div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{event.urovenMeropriyatiya.opisanie}</span>
				</div>
				<div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Место проведения: </span>
					<span className={classes.fieldValue}>{event.mestoProvedeniya.name}</span>
				</div> */}
			</div>
			<div style={{ paddingTop: "10px" }}>
				<div style={(size !== "small") ? { marginTop: "7px" } : {}}>
					<div style={{
						backgroundColor: "#eaeaea",
						fontSize: "14px",
						fontWeight: "400",
						color: "black",
						borderRadius: "6px",
						textAlign: "center",
						padding: "0 7px",
						textAlign: "center",
					}}>
						<div style={{
							borderRadius: "5px",
							backgroundColor: "#f6214b",
							fontSize: "12px",
							fontWeight: "600",
							color: "white",
							margin: "0 -7px",
							boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
							padding: "3px 7px"
						}}>
							{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
						</div>
						<div style={{
							fontSize: "10px",
							fontWeight: "400",
							padding: "0px"
						}}>
							{moment(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default function Myevents(props) {
	const classes = useStyles();
	const auth = useAuth();
	const dispatch = useDispatch();

	const meta = useSelector(state => state.meta);

	const user = useSelector(state => state.home.user);
	const role = useSelector(state => state.home.role, () => { });
	const role_by_id = useSelector(state => state.home.role_by_id);
	const role_by_name = useSelector(state => state.home.role_by_name);

	const { t } = useTranslation()

	const [tickets, setTickets] = React.useState();
	useEffect(() => {
		GET(auth, "/api/my-meropriyatiya", ({ data }) => {
			if (data) {
				setTickets(o => {
					let r = data.map(e => ({
						Data: "",
						Meropriyatie: e,
						TicketList: []
					}))
					return r.sort((a, b) => {
						if (a?.Meropriyatie?.nachaloSorevnovaniya > b?.Meropriyatie?.nachaloSorevnovaniya) return 1;
						if (a?.Meropriyatie?.nachaloSorevnovaniya == b?.Meropriyatie?.nachaloSorevnovaniya) return 0;
						if (a?.Meropriyatie?.nachaloSorevnovaniya < b?.Meropriyatie?.nachaloSorevnovaniya) return -1;
					});
				});

				GET(auth, "/api/ticket/actual", ({ data }) => {
					if (data) {
						setTickets(o => {

							let r = _.unionWith(o, data, (a, b) => a.Meropriyatie.ID === b.Meropriyatie.ID);

							for (let i = 0; i < r.length; i++) {
								const ev = r[i];
								let t = data.find(fo => fo.Meropriyatie.ID === ev.Meropriyatie.ID);
								if (t) {
									r[i] = {
										...r[i],
										Data: t.Data,
										TicketList: t.TicketList
									}
								}
							}

							return r.sort((a, b) => {
								if (a?.Meropriyatie?.nachaloSorevnovaniya > b?.Meropriyatie?.nachaloSorevnovaniya) return 1;
								if (a?.Meropriyatie?.nachaloSorevnovaniya == b?.Meropriyatie?.nachaloSorevnovaniya) return 0;
								if (a?.Meropriyatie?.nachaloSorevnovaniya < b?.Meropriyatie?.nachaloSorevnovaniya) return -1;
							});
						});
					}
				}, errorCatch)
			}
		}, errorCatch)
	}, []);

	return (
		<>
			<Block style={{ paddingBottom: "25px" }}
				title={<>
					{/* <span>Мои мероприятия</span> */}
				</>} /*background={"#ffefef"}*/ >
				<div style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", gap: "0px 10px" }}>
					{JSXMap(tickets, (e, idx) => {
						const appendYacheikaUsluga = (arr, tick) => {
							let a = (arr) ? [...arr] : [];
							a.push({
								...tick.uslugaKlientu.yacheikaUsluga,
								kategoriya: (tick.kategoriya && tick.kategoriya.kategoriya) ? tick.kategoriya.kategoriya : undefined,
							});

							return a.sort(function (a, b) {
								if (a.kategoriya && !b.kategoriya) {
									return -1;
								}
								if (!a.kategoriya && b.kategoriya) {
									return 1;
								}
								return 0;
							});;
						};
						const ticket = () => {
							let m = {};

							for (let i = 0; i < e.TicketList.length; i++) {
								const tick = e.TicketList[i];
								let o = m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] || tick.uslugaKlientu.uslugaNaMeropriyatii;
								o = {
									...o,
									summa: ((o.summa) ? o.summa : 0) + tick.summa,
									yacheikaUsluga: appendYacheikaUsluga(o.yacheikaUsluga, tick),
								};
								m[tick.uslugaKlientu.uslugaNaMeropriyatii.ID] = o;
							}
							return Object.values(m);
						};
						return (<div key={idx} style={{ flex: "1 1 556px" }}>
							<EventListItem
								key={idx}
								event={e.Meropriyatie}
								qr={e?.Data}
								tickets={ticket()}
								eventUsers={e?.Meropriyatie?.eventUserMeropriyatie}
								// size="medium"
								size={(idx === 0) ? "large" : (dayjs(e?.Meropriyatie?.nachaloSorevnovaniya).isBefore(dayjs().add(14, 'day'))) ? "medium" : "small"}
								extButtons={({ path, size, style }) => [
									If(eventRoleControler(e?.Meropriyatie), <div key="controller">
										<a
											style={style}
											className={`btn btn-soft-secondary btn-sm`}
											href={`/app/checkticket/${e?.Meropriyatie?.ID}`}
										>
											{(size === "small") && <span><i className="fa fa-ticket"></i> </span>}
											{(size === "medium") && <span><i className="fa fa-ticket"></i> Проверка</span>}
											{(size === "large") && <span><i className="fa fa-ticket"></i> Проверка билетов</span>}
										</a>
									</div>)
								]}

							/>
						</div>)
					})}
				</div>
			</Block>
		</>
	);
}
